document.addEventListener('DOMContentLoaded', function() {
    const footerSwiper = new Swiper('.footer-product-swiper', {
    loop: true,
    slidesPerView: 'auto',
    spaceBetween: 10,
    freeMode: false,
    navigation: {
        nextEl: '.swiper-button-next-footer',
        prevEl: '.swiper-button-prev-footer',
    },
    breakpoints: {
        768: {
        spaceBetween: 10
        }
    }
    });
});
